import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { requiredPermissionForPath } from '@/app/navigation';
import { usePermission } from '@/permissions/usePermission';

// Client-side per-route permission gate. Mirrors the sidebar's visibility rules
// so that navigating directly by URL to a page the user lacks is blocked on the
// client too. The backend [Authorize] on every app-service remains the real
// security boundary — this is a UX guard, not a substitute for it.
export function RoutePermissionGuard({ children }: { children: ReactNode }) {
  const location = useLocation();
  const can = usePermission();
  const permission = requiredPermissionForPath(location.pathname);

  if (permission && !can(permission)) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center text-center py-5">
        <i className="fe fe-lock fs-1 text-muted mb-3" />
        <h5 className="mb-1">Access denied</h5>
        <p className="text-muted mb-0">You don't have permission to view this page.</p>
      </div>
    );
  }

  return <>{children}</>;
}
